// Utility function for pools page
export const getPoolsUrl = (): string => {
  // Both borrowers and investors now use the same /pools route
  return '/pools';
};
